import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { ArrowDropDown, ArrowRight, Circle, Delete, Edit } from '@mui/icons-material';

import { useDispatch, useSelector } from 'react-redux';

import AddPNFSales from '../../../components/modals/AddPNFSales';
import AddPNFPurchase from '../../../components/modals/AddPNFPurchase';
import AddPNFCreditNote from '../../../components/modals/AddPNFCreditNote';
import AddPNFJournal from '../../../components/modals/AddPNFJournal';
import AddPNFDebitNote from '../../../components/modals/AddPNFDebitNote';
import AddBalanceSheetPayment from '../../../components/modals/AddBalanceSheetPayment';

import useMediaQuery from '@mui/material/useMediaQuery';

import { useNavigate } from 'react-router-dom';
import { setTableRowCount } from '../../../redux/reducers/DashboardSlice';
import { MoneyFormatv3 } from '../../../library/MoneyFormat';
import { dashboardApi } from '../../../redux/apis/dashboardApi';
import { useDeleteAccountMasterMutation } from '../../../redux/apis/accountMaster.api';
import { useDeleteAccountGroupMasterMutation } from '../../../redux/apis/accountGroupMaster.api';
import { useThemes } from '../../../components/Theme/theme';
import { settingsClose } from '../../../redux/reducers/companySkipSave';
import CreateAndEditLedger from '../../../components/modals/CreateAndEditLedger';
import { handleFreeze } from '../../../utils/common';
import CreateAndEditGroupModal from '../../../components/modals/CreateAndEditGroupModal';
import DeleteLedgerGroup from '../../../components/modals/DeleteLedgerGroup';
import AddBalanceSheetReceipt from '../../../components/modals/AddBalanceSheetReceipt';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import ActionButtons from '../../../components/Buttons/ActionButtons';
import { LedgerModal, useLedgerModalHandle } from '../../../features/AccountsAndGroups';

const buttonStyle = {
  borderRadius: 10,
  color: '#297179',
  // borderColor: '#72c4cd',
  // borderWidth: 3,
  backgroundColor: '#FFF',
  fontFamily: 'overpass',
  fontWeight: '700',
  fontSize: 15,
  paddingTop: 0.5,
  paddingBottom: 0.5,
  PaddingLeft: 1,
  paddingRight: 1,
  marginBottom: 1,
};

const RecursiveTableRow = ({
  row,
  level = 0,
  expandedRows,
  toggleExpandRow,
  commonStyle,
  setSelectedRow,
  setGroupName,
  setCreateGroupModal,
  setOpenModal,
  newLedgerAccountID,
  hideAmount,
  hidePandLToggleClicked,
  setAccountID,
  handleSelectRow,
}) => {
  const { theme } = useThemes();
  let isExpanded = expandedRows.includes(row?.id);
  level = row?.category === 'profitability' ? 1 : level;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {hidePandLToggleClicked && row?.balance === 0 && row.category === 'ledger' ? (
        ''
      ) : (
        <TableRow
          className="noFocusTableRow"
          style={{
            height: commonStyle.rowHeight,
            p: 0,
            borderLeft: '1px solid #C0C0C0',
            borderRight: '1px solid #C0C0C0',
          }}
        >
          <TableCell
            className="noFocusTableCell"
            component="th"
            scope="row"
            sx={{
              padding: 0,
              margin: 0,
              maxWidth: matches ? '250px' : '300px',
              borderRight: '4px solid !important',
              borderRightColor: `${theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0'} !important`,
              '.button-container': {
                display: 'none',
              },
              '.hover-default': {
                display: 'none',
              },
              '&:hover': {
                '.button-container': {
                  display: 'flex',
                },
                '.hover-default': {
                  display: matches ? 'none' : 'block',
                },
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                // backgroundColor:"black",
                width: { xs: '250px', sm: '100%' },
              }}
            >
              <Stack
                direction="row"
                sx={{
                  width: { xs: '80%', lg: '100%' },
                  whiteSpace: 'nowrap',
                  overflow: isSmallScreen ? 'auto' : 'hidden',
                  scrollbarWidth: 'none',
                  // Hide scrollbar - IE & Edge
                  msOverflowStyle: 'none',

                  // Hide scrollbar - Chrome, Safari
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                  textOverflow: isSmallScreen ? 'clip' : 'ellipsis',
                }}
              >
                  <Box
                    sx={{
                      paddingLeft: `${level * 10}px`,
                      maxWidth: { lg: '90%' },
                      whiteSpace: { lg: 'nowrap' },
                      overflow: { lg: 'hidden' },
                      textOverflow: { lg: 'ellipsis' },
                      fontSize: { xs: '12px', sm: '13px' },
                      cursor: row.category === 'ledger' ? 'pointer' : 'default',
                      color:
                        row?.category == 'label'
                          ? '#818694'
                          : row?.category === 'group'
                          ? 'primary.main'
                          : row?.name === 'Net Loss'
                          ? '#d40217'
                          : theme?.palette?.TmId.id.toString().includes('9')
                          ? '#fff'
                          : '#000000',
                      fontWeight: row?.category !== 'ledger' ? 'bold' : '',
                    }}
                    onClick={row?.category === 'ledger' ? () => setAccountID(row?.id) : undefined}
                  >
                  {row?.category === 'group' ? (
                    <IconButton
                      aria-label={isExpanded ? 'collapse' : 'expand'}
                      size="small"
                      onClick={() => toggleExpandRow(row?.id)}
                      style={{ padding: 0, margin: 0 }}
                    >
                      {isExpanded ? <ArrowDropDown /> : <ArrowRight />}
                    </IconButton>
                  ) : (
                    row?.category !== 'profitability' &&
                    row?.category !== 'label' && (
                      <IconButton size="small" onClick={() => toggleExpandRow(row?.id)} style={{ padding: 0, margin: 0 }}>
                        <Circle
                          sx={{
                            width: 10,
                            height: 10,
                            color: '#ee5b2b',
                            marginRight: 1.5,
                            marginLeft: 0.8,
                          }}
                        />
                      </IconButton>
                    )
                  )}
                  <Tooltip title={
                    row?.name?.startsWith('EBITDA') ? 'Earnings Before Interest, Taxes, and Amortization' :
                    row?.name?.startsWith('EBIT') ? 'Earnings Before Interest and Taxes' :
                    row?.name?.startsWith('PBT') ? 'Profit Before Tax' :
                    row?.name
                  }>
                    {row?.name}
                  </Tooltip>
                </Box>
                {row?.restrictedflag === 1 && (
                  <Typography
                    className="hover-default"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      marginLeft: 0.5,
                      color: '#818694',
                    }}
                    textAlign="center"
                    variant="body2"
                    fontStyle="italic"
                  >
                    {row?.category === 'ledger' ? 'Default A/C' : 'Default Group'}
                  </Typography>
                )}
                {newLedgerAccountID === (row?.category === 'group' ? row?.id : row?._id) && (
                  <Box
                    sx={{
                      backgroundColor: '#FF004D',
                      color: '#FFF',
                      borderRadius: 10,
                      marginLeft: 1.5,
                      fontSize: 10,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '1px 10px',
                      fontWeight: 'bold',
                    }}
                  >
                    New
                  </Box>
                )}
              </Stack>
              <ActionButtons
                key={row?.id}
                item={row}
                handleSelectRow={handleSelectRow}
                isSmallScreen={isSmallScreen}
                theme={theme}
                bgcolor={theme.palette.primary.main}
              />
            </Box>
          </TableCell>
          <TableCell
            align="right"
            className="noFocusTableCell"
            sx={{
              padding: 0,
              margin: 0,
              paddingRight: '5px',
              fontSize: { xs: '12px', sm: '13px' },
              color:
                row?.balance < 0
                  ? 'red'
                  : row?.category === 'group'
                  ? theme.palette.primary.main
                  : theme?.palette?.TmId.id.toString().includes('9')
                  ? '#fff'
                  : '#000000',
              fontWeight: row?.category !== 'ledger' ? 'bold' : '',
              width: '20%',
            }}
          >
            {hideAmount && row?.category === 'group' ? '' : '₹ ' + MoneyFormatv3(row?.balance)}
          </TableCell>
          {/* Example data */}
        </TableRow>
      )}

      {isExpanded &&
        row?.children &&
        row?.children.length > 0 &&
        row?.children.map((child) => (
          <RecursiveTableRow
            key={child.id}
            row={child}
            level={level + 1}
            expandedRows={expandedRows}
            toggleExpandRow={toggleExpandRow}
            commonStyle={commonStyle}
            setSelectedRow={setSelectedRow}
            setGroupName={setGroupName}
            setCreateGroupModal={setCreateGroupModal}
            setOpenModal={setOpenModal}
            newLedgerAccountID={newLedgerAccountID}
            hideAmount={hideAmount}
            hidePandLToggleClicked={hidePandLToggleClicked}
            setAccountID={setAccountID}
            handleSelectRow={handleSelectRow}
          />
        ))}
    </>
  );
};

function ProfitNLossTableNew({
  heading,
  rows,
  rows2,
  headColor,
  firstTotal,
  mainTotal,
  grossProfitorLoss,
  grossLoss,
  grossProfit,
  grossbdProfitorLoss,
  grossbdProfit,
  grossbdLoss,
  options,
  setNewLedgerResponse,
  expandButtonClicked,
  netProfit,
  profitorLoss,
  netLoss,
  openingStock,
  asOnDate,
  closingStockValue,
  newLedgerAccountID,
  hideAmount,
  hidePandLToggleClicked,
  setAccountID,
  refetchDb,
  totalTradingExpense,
  startTimeStamp,
  endTimeStamp,
}) {
  const { theme } = useThemes();

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [createLedgerModal, setCreateLedgerModal] = useState(false);
  const [openModal, setOpenModal] = useState({
    groupModal: false,
    ledgerModal: false,
    editModal: false,
    editGroupModal: false,
    deleteModal: false,
    transcationModal: false,
    receiptModal: false,
    journalModal: false,
    paymentModal: false,
    debitNoteModal: false,
    creditNoteModal: false,
    salesModal: false,
    purchaseModal: false,
  });
  const initialEbitaIds = ['EBITDA', 'EBIT', 'PBT'];
  const [expandedRows, setExpandedRows] = useState(initialEbitaIds);
  const [emptyRowCount, setEmptyRowCount] = useState(0);
  const [emptyRowCount2, setEmptyRowCount2] = useState(0);
  const [createGroupModal, setCreateGroupModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [groupData, setGroupData] = useState('');
  const [groupName, setGroupName] = useState('');
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [updatedata, setUpdatedata] = useState('');
  const [deleteId, setdeleteId] = useState('');
  const [ledgerDetails, setLedgerDetails] = useState({
    group: { accountTypeCD: '', label: '', value: '' },
    name: '',
    accountsID: '',
    cess: '',
    cessType: '',
    displayOrderNo: '',
    gstrate: '',
    hsnCode: { label: '', value: '' },
    name: '',
  });

  const [ledgerData, setLedgerData] = useState('');
  const [gstData, setGstData] = useState({});
  const [autoExpand, setAutoExpand] = useState([]);

  const profitandLossReducer = useSelector((state) => state.DashboardDataReducer.profitNLoss);

  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);

  const isVertical = profitandLossReducer?.isVertical;

  const toggleExpandRow = (id) => {
    setExpandedRows((prevState) => (prevState.includes(id) ? prevState.filter((rowId) => rowId !== id) : [...prevState, id]));
  };

  const handleExpandAll = () => {
    const allRowIds = [];
    const getAllIds = (rows) => {
      rows.forEach((row) => {
        allRowIds.push(row?.id);
        if (row?.children && row?.children.length > 0) {
          getAllIds(row?.children);
        }
      });
    };
    getAllIds([...rows, ...rows2]);
    setExpandedRows(allRowIds);
  };

  const handleCollapseAll = () => {
    setExpandedRows(initialEbitaIds);
  };


  useEffect(() => {
    const expandAncestors = (row, autoExpand) => {
      if (autoExpand.some((item) => item.id === row._id && !item.expand)) {
        setAutoExpand((prev) => prev.map((item) => (item.id === row._id ? { ...item, expand: true } : item)));
        setExpandedRows((prev) => {
          if (!prev.includes(row._id)) {
            return [...prev, row._id];
          }
          return prev;
        });

        return true;
      }

      if (row.children) {
        for (let child of row.children) {
          if (expandAncestors(child, autoExpand)) {
            setExpandedRows((prev) => {
              if (!prev.includes(row._id)) {
                return [...prev, row._id];
              }
              return prev;
            });
            return true;
          }
        }
      }
      return false;
    };

    [...rows, ...rows2].forEach((row) => {
      if (autoExpand.length > 0) {
        if (expandAncestors(row, autoExpand)) {
          setExpandedRows((prev) => {
            if (!prev.includes(row._id)) {
              return [...prev, row._id];
            }
            return prev;
          });
        }
      }
    });
  }, [autoExpand, rows, rows2]);

  const countDisplayedRows = (rows, expandedRows) => {
    let count = 0;

    rows.forEach((row) => {
      if (hidePandLToggleClicked && row?.balance === 0 && row.category === 'ledger') {
        return;
      }

      count += 1;

      if (expandedRows?.includes(row?.id) && row?.children && row?.children.length > 0) {
        count += countDisplayedRows(row?.children, expandedRows);
      }
    });

    return count;
  };

  useEffect(() => {
    if (expandButtonClicked && rows.length > 0 && rows2.length > 0) {
      handleExpandAll();
    } else {
      handleCollapseAll();
    }
  }, [expandButtonClicked, rows, rows2]);

  useEffect(() => {
    const newRowCount = countDisplayedRows(rows, expandedRows);

    const key = heading === 'Income' ? 'table2' : 'table1';

    if (profitandLossReducer.tableRowCount[key] !== newRowCount) {
      dispatch(setTableRowCount({ key, count: newRowCount }));
    }
  }, [expandedRows, rows, heading, profitandLossReducer.tableRowCount, dispatch, hidePandLToggleClicked]);

  useEffect(() => {
    const newRowCount = countDisplayedRows(rows2, expandedRows);

    const key = heading === 'Income' ? 'table4' : 'table3';

    if (profitandLossReducer.tableRowCount[key] !== newRowCount) {
      dispatch(setTableRowCount({ key, count: newRowCount }));
    }
  }, [expandedRows, rows2, heading, profitandLossReducer.tableRowCount, dispatch, hidePandLToggleClicked]);

  useEffect(() => {
    const table1RowCount = profitandLossReducer.tableRowCount.table1;
    const table2RowCount = profitandLossReducer.tableRowCount.table2;

    const maxRowCount = Math.max(table1RowCount, table2RowCount);

    const key = heading === 'Income' ? 'table2' : 'table1';

    let rowDifference = maxRowCount - profitandLossReducer.tableRowCount[key];

    if (heading === 'Income') {
      rowDifference = rowDifference + 1;
    }
    if (rowDifference > 0) {
      setEmptyRowCount(rowDifference);
    } else {
      setEmptyRowCount(0);
    }
  }, [profitandLossReducer, heading, dispatch]);

  const handleOpenModal = (key) => {
    if (key in openModal) {
      setOpenModal((prev) => ({ ...prev, [key]: !prev[key] }));
    }
  };

  useEffect(() => {
    const table1RowCount = profitandLossReducer.tableRowCount.table3;
    const table2RowCount = profitandLossReducer.tableRowCount.table4;

    const maxRowCount = Math.max(table1RowCount, table2RowCount);

    const key = heading === 'Income' ? 'table4' : 'table3';

    const rowDifference = maxRowCount - profitandLossReducer.tableRowCount[key];

    if (rowDifference > 0 && !isVertical) {
      setEmptyRowCount2(rowDifference);
    } else {
      setEmptyRowCount2(0);
    }
  }, [profitandLossReducer, heading, dispatch]);

  const commonStyle = {
    rowHeight: 35,
    fontSize: 13,
  };

  const otherStyle = {
    rowHeight: 35,
    fontSize: 13,
  };


  useEffect(() => {
    if (deleteId !== '') {
      setBackdropOpen(true);
      deleteLedgers();
      setdeleteId('');
    }
  }, [deleteId]);

  const [deleteAccountGroupMaster] = useDeleteAccountGroupMasterMutation();
  const [deleteAccountMaster] = useDeleteAccountMasterMutation();

  async function deleteLedgers() {
    if (deleteId.category === 'group') {
      try {
        const response = await deleteAccountGroupMaster({
          accountgroupid: deleteId.id,
        });

        if (response.data !== null) {
          setBackdropOpen(false);
        }

        if (response?.data?.statuscode === 'Error') {
          setBackdropOpen(false);
          showWarningSnackbar(response?.data?.statusmessage);
        } else {
          setBackdropOpen(false);
          showSuccessSnackbar('Group Deleted');
        }
      } catch (error) {
        console.log(error);
        setBackdropOpen(false);
      }
    }
    if (deleteId.category === 'ledger') {
      try {
        const response = await deleteAccountMaster({ accountsid: deleteId.id });
        let { statuscode, statusmessage } = response.data;

        if (statuscode === 'Error') {
          if (statusmessage.includes('Transactions Already Recorded')) {
            showWarningSnackbar('Cannot delete ledger account : Transactions exists in the current year');
          } else {
            showWarningSnackbar(statusmessage);
          }
        } else {
          showSuccessSnackbar('Ledger Deleted');
        }
      } catch (error) {
        console.log(error);
        setBackdropOpen(false);
      }
    }
    dispatch(dashboardApi.util.invalidateTags(['dashboard']));
  }

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  const { openLedgerModal, closeLedgerModal, ledgerModalParams } = useLedgerModalHandle();

  const handleSelectRow = useCallback((row) => {
    setSelectedRow(row);

    if (Freeze === 1) return handleFreeze();

    const { modal, category, action, id, parent, name } = row || {};

    if (modal === 'ledger') {
      openLedgerModal({
        groupId: category === 'group' ? id : parent,
        accountId: action === 'edit' ? id : '',
        title: action === 'edit' ? name : '',
        filterAccountTypeCd: 'PandL',
        restrictedflag: row?.restrictedflag,
      });
    } else {
      handleOpenModal(action === 'delete' ? 'deleteModal' : 'groupModal');
    }
  }, []);

  const handleLedgerModal = ({ accountsId }) => {
    setNewLedgerResponse(selectedRow?.action === 'create' ? accountsId + 'ledger' : null);
    setSelectedRow(null);
  };

  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <>
      <Table aria-label="recursive table">
        <TableHead>
          <TableRow className="noFocusTableCell" sx={{ height: '45px' }}>
            <TableCell
              sx={{
                borderBottom: '1px solid',
                borderBottomColor: `${headColor} !important`,
                backgroundColor: `${headColor} !important`,
                borderTopLeftRadius: 5,
                color: '#818694',
                borderLeftColor: `${headColor} !important`,
                borderRight: '4px solid',
                borderRightColor: theme?.palette?.TmId.id?.toString().includes('9') ? '#26262F' : '#ffffff',
                padding: '4px 8px', // optional: control padding for height
              }}
            >
              <Box sx={{ fontSize: { xs: '14px', sm: '16px' } }}>
                <div
                  style={{
                    width: '100%',
                    color: '#FFF',
                    letterSpacing: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontFamily: 'overpass',
                    // fontSize: {xs:"14px", sm:"20px"},
                    height: '20px', // apply height to div content
                  }}
                >
                  <span>{heading}</span>
                </div>
              </Box>
            </TableCell>

            <TableCell
              sx={{
                backgroundColor: `${headColor} !important`,
                borderTopRightRadius: 5,
                borderLeftColor: theme?.palette?.TmId.id?.toString().includes('9') ? '#26262F' : '#EEEEFA',
                position: 'relative',
                padding: '4px 8px', // optional: consistent padding
              }}
            >
              <Box sx={{ fontSize: { xs: '14px', sm: '16px' } }}>
                <div
                  style={{
                    width: '100%',
                    color: '#FFF',
                    letterSpacing: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: 'overpass',
                    // fontSize: {xs:"14px", sm:"16px"},
                    height: '20px',
                  }}
                >
                  <span>Amount</span>
                </div>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody
          sx={{
            '.MuiTableCell-root': {
              backgroundColor: 'transparent !important',
            },
          }}
        >
          {/* OpeningStock Row */}
          {heading === 'Expense' && (
            <TableRow
              className="noFocusTableCell"
              style={{
                height: otherStyle?.rowHeight,
                borderLeft: '1px solid #C0C0C0',
                borderRight: '1px solid #C0C0C0',
                borderBottom: '2px solid #C0C0C0',
              }}
            >
              <TableCell
                style={{
                  padding: 0,
                  margin: 0,
                  borderRight: '4px solid',
                  borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                  paddingLeft: '10px',
                  fontWeight: 'bold',
                  // color: "#818694",
                  color: 'black',
                  fontSize: otherStyle.fontSize,
                  height: otherStyle.rowHeight,
                }}
              >
                Opening Stock
              </TableCell>
              <TableCell
                align="right"
                style={{
                  padding: 0,
                  margin: 0,
                  paddingRight: '5px',
                  fontWeight: 'bold',
                  fontSize: otherStyle.fontSize,
                  height: otherStyle.rowHeight,
                }}
              >
                ₹ {MoneyFormatv3(openingStock && Object.keys(openingStock).length > 0 && openingStock.balance)}
              </TableCell>
            </TableRow>
          )}
          {/* Closing stock Row */}
          {heading === 'Income' && (
            <TableRow
              className="noFocusTableCell"
              style={{
                height: otherStyle?.rowHeight,
                borderLeft: '1px solid #C0C0C0',
                borderRight: '1px solid #C0C0C0',
                borderBottom: '2px solid #C0C0C0',
              }}
            >
              <TableCell
                onClick={() => {
                  navigate('/reports', {
                    state: {
                      startTimeStamp,
                      endTimeStamp,
                      period: `${
                        startTimeStamp && endTimeStamp
                          ? `${new Date(startTimeStamp * 1000).toLocaleDateString()} - ${new Date(
                              endTimeStamp * 1000
                            ).toLocaleDateString()}`
                          : 'Current Period'
                      }`,
                    },
                  });
                }}
                style={{
                  padding: 0,
                  margin: 0,
                  borderRight: '4px solid ',
                  borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                  paddingLeft: '10px',
                  fontWeight: 'bold',
                  // color: "#818694",
                  color: 'black',
                  fontSize: commonStyle.fontSize,
                }}
              >
                {`Closing Stock ${asOnDate ? `As On ${asOnDate}` : ''}`}
              </TableCell>
              <TableCell
                align="right"
                style={{
                  padding: 0,
                  margin: 0,
                  paddingRight: '5px',
                  fontWeight: 'bold',
                  fontSize: commonStyle.fontSize,
                }}
              >
                {'₹ ' + MoneyFormatv3(closingStockValue)}
              </TableCell>
            </TableRow>
          )}

          {/* Row 1 */}
          {rows.map((row) => (
            <RecursiveTableRow
              key={row?.id}
              row={row}
              expandedRows={expandedRows}
              toggleExpandRow={toggleExpandRow}
              commonStyle={commonStyle}
              setSelectedRow={setSelectedRow}
              setGroupName={setGroupName}
              setCreateGroupModal={setCreateGroupModal}
              setOpenModal={(e) => handleOpenModal(e)}
              newLedgerAccountID={newLedgerAccountID}
              hideAmount={hideAmount}
              hidePandLToggleClicked={hidePandLToggleClicked}
              setAccountID={setAccountID}
              handleSelectRow={handleSelectRow}
            />
          ))}

          {!isVertical &&
            [...Array(emptyRowCount).keys()].map((_, index) => (
              <TableRow
                key={index + 'part2'}
                className="noFocusTableCell"
                sx={{
                  height: otherStyle?.rowHeight,
                  borderLeft: '1px solid #C0C0C0',
                  borderRight: '1px solid #C0C0C0',
                  display: { xs: 'none', lg: 'table-row' },
                }}
              >
                <TableCell
                  style={{
                    padding: 0,
                    margin: 0,
                    borderRight: '4px solid ',
                    borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                  }}
                ></TableCell>
                <TableCell style={{ padding: 0, margin: 0 }}></TableCell>
              </TableRow>
            ))}
          {/* Total Trading expense Label */}
          {heading === 'Expense' && (
            <TableRow
              className="noFocusTableCell"
              style={{
                height: otherStyle?.rowHeight,
                borderLeft: '1px solid #C0C0C0',
                borderRight: '1px solid #C0C0C0',
                borderBottom: '2px solid #C0C0C0',
                borderTop: '2px solid #C0C0C0',
              }}
            >
              <TableCell
                style={{
                  padding: 0,
                  margin: 0,
                  borderRight: '4px solid ',
                  borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                  paddingLeft: '10px',
                  fontWeight: 'bold',
                  fontSize: otherStyle.fontSize,
                }}
              >
                Total Trading Expense
              </TableCell>
              <TableCell
                align="right"
                style={{
                  padding: 0,
                  margin: 0,
                  fontWeight: 'bold',
                  paddingRight: '5px',
                  fontSize: otherStyle.fontSize,
                }}
              >
                ₹ {MoneyFormatv3(totalTradingExpense) || 0}
              </TableCell>
            </TableRow>
          )}
          {!isVertical && !isMediumScreen && (
            <>
              {/* Gross Profit c/f */}
              {heading === 'Expense' && grossProfit !== 0 && (
                <TableRow
                  className="noFocusTableCell"
                  style={{
                    height: otherStyle?.rowHeight,
                    borderLeft: '1px solid #C0C0C0',
                    borderRight: '1px solid #C0C0C0',
                    borderBottom: '2px solid #C0C0C0',
                  }}
                >
                  <TableCell
                    style={{
                      padding: 0,
                      margin: 0,
                      borderRight: '4px solid ',
                      borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                      paddingLeft: '10px',
                      fontWeight: 'bold',
                      color: 'green',
                      fontSize: otherStyle.fontSize,
                    }}
                  >
                    {grossProfitorLoss === 'profit' && 'Gross Profit c/f'}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{
                      padding: 0,
                      margin: 0,
                      color: 'green',
                      fontWeight: 'bold',
                      paddingRight: '5px',
                      fontSize: otherStyle.fontSize,
                    }}
                  >
                    {grossProfitorLoss === 'profit' && '₹ ' + MoneyFormatv3(grossProfit)}
                  </TableCell>
                </TableRow>
              )}

              {/* gross loss cf */}
              {heading === 'Income' && grossLoss !== 0 && (
                <TableRow
                  className="noFocusTableCell"
                  style={{
                    height: otherStyle?.rowHeight,
                    borderLeft: '1px solid #C0C0C0',
                    borderRight: '1px solid #C0C0C0',
                    borderBottom: '2px solid #C0C0C0',
                  }}
                >
                  <TableCell
                    style={{
                      padding: 0,
                      margin: 0,
                      borderRight: '4px solid ',
                      borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                      paddingLeft: '10px',
                      fontWeight: 'bold',
                      color: 'red',
                      fontSize: otherStyle.fontSize,
                    }}
                  >
                    {grossProfitorLoss === 'loss' && 'Gross Loss c/f'}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{
                      padding: 0,
                      margin: 0,
                      paddingRight: '5px',
                      color: 'red',
                      fontWeight: 'bold',
                      fontSize: otherStyle.fontSize,
                    }}
                  >
                    {grossProfitorLoss === 'loss' && '₹ ' + MoneyFormatv3(Number(grossLoss))}
                  </TableCell>
                </TableRow>
              )}

              <TableRow
                className="noFocusTableCell"
                sx={{
                  height: otherStyle?.rowHeight,
                  borderLeft: '1px solid #C0C0C0',
                  borderRight: '1px solid #C0C0C0',
                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#373a36' : theme?.palette?.bodyGray.tertiary,
                }}
              >
                <TableCell
                  sx={{
                    padding: 0,
                    margin: 0,
                    borderRight: '4px solid ',
                    borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#ffff',
                    paddingLeft: '10px',
                    fontWeight: 'bold',
                    fontSize: { xs: '16px', sm: '16px' },
                  }}
                >
                  Total
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    padding: 0,
                    margin: 0,
                    paddingRight: '5px',
                    fontWeight: 'bold',
                    fontSize: { xs: '14px', sm: '16px' },
                    whiteSpace: 'nowrap',
                  }}
                >
                  {'₹ ' + MoneyFormatv3(firstTotal)}
                </TableCell>
              </TableRow>
            </>
          )}

          {!isVertical && !isMediumScreen && (
            <>
              {/* Gross Profit b/d */}

              {heading === 'Income' && grossbdLoss !== 0 && (
                <TableRow
                  className="noFocusTableCell"
                  style={{
                    height: otherStyle?.rowHeight,
                    borderLeft: '1px solid #C0C0C0',
                    borderRight: '1px solid #C0C0C0',
                    borderBottom: '2px solid #C0C0C0',
                  }}
                >
                  <TableCell
                    style={{
                      padding: 0,
                      margin: 0,
                      borderRight: '4px solid ',
                      borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                      paddingLeft: '10px',
                      fontWeight: 'bold',
                      color: 'green',
                      fontSize: otherStyle?.fontSize,
                    }}
                  >
                    {grossbdProfitorLoss === 'loss' && 'Gross Profit b/d'}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{
                      padding: 0,
                      margin: 0,
                      color: 'green',
                      fontWeight: 'bold',
                      paddingRight: '5px',
                      fontSize: otherStyle?.fontSize,
                    }}
                  >
                    {heading === 'Income' && grossbdProfitorLoss === 'loss' && '₹ ' + MoneyFormatv3(Number(grossbdLoss))}
                  </TableCell>
                </TableRow>
              )}

              {/* Gross Loss b/d*/}
              {heading === 'Expense' && grossbdProfit !== 0 && (
                <TableRow
                  className="noFocusTableCell"
                  style={{
                    height: otherStyle?.rowHeight,
                    borderLeft: '1px solid #C0C0C0',
                    borderRight: '1px solid #C0C0C0',
                    borderBottom: '2px solid #C0C0C0',
                  }}
                >
                  <TableCell
                    style={{
                      padding: 0,
                      margin: 0,
                      borderRight: '4px solid ',
                      borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                      paddingLeft: '10px',
                      fontWeight: 'bold',
                      color: 'red',
                      fontSize: otherStyle.fontSize,
                    }}
                  >
                    {grossbdProfitorLoss === 'profit' && 'Gross Loss b/d'}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{
                      padding: 0,
                      margin: 0,
                      color: 'red',
                      fontWeight: 'bold',
                      paddingRight: '5px',
                      fontSize: otherStyle.fontSize,
                    }}
                  >
                    {grossbdProfitorLoss === 'profit' && '₹ ' + MoneyFormatv3(Number(grossbdProfit))}
                  </TableCell>
                </TableRow>
              )}
            </>
          )}

          {rows2.map((row) => (
            <RecursiveTableRow
              key={row?.id}
              row={row}
              expandedRows={expandedRows}
              toggleExpandRow={toggleExpandRow}
              commonStyle={commonStyle}
              setSelectedRow={setSelectedRow}
              setGroupName={setGroupName}
              setCreateGroupModal={setCreateGroupModal}
              setOpenModal={handleOpenModal}
              newLedgerAccountID={newLedgerAccountID}
              hideAmount={hideAmount}
              hidePandLToggleClicked={hidePandLToggleClicked}
              setAccountID={setAccountID}
              handleSelectRow={handleSelectRow}
            />
          ))}
          {!isVertical &&
            [...Array(emptyRowCount2).keys()].map((_, index) => (
              <TableRow
                key={index + 'part1'}
                className="noFocusTableCell"
                sx={{
                  display: { xs: 'none', lg: 'table-row' },
                  height: otherStyle?.rowHeight,
                  borderLeft: '1px solid #C0C0C0',
                  borderRight: '1px solid #C0C0C0',
                }}
              >
                <TableCell
                  style={{
                    padding: 0,
                    margin: 0,
                    borderRight: '4px solid ',
                    borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                  }}
                ></TableCell>
                <TableCell style={{ padding: 0, margin: 0 }}></TableCell>
              </TableRow>
            ))}

          {/* // Net Profit */}
          {heading === 'Expense' && (
            <TableRow
              style={{
                height: otherStyle?.rowHeight,
                borderLeft: '1px solid #C0C0C0',
                borderRight: '1px solid #C0C0C0',
              }}
            >
              <TableCell
                style={{
                  padding: 0,
                  margin: 0,
                  borderRight: '4px solid ',
                  borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                  fontWeight: 'bold',
                  paddingLeft: '10px',
                  color: 'green',
                  fontSize: otherStyle.fontSize,
                }}
              >
                <Tooltip title="Profit After tax" placement="top">
                  {profitorLoss === 'profit' && 'Net Profit'}
                </Tooltip>
              </TableCell>
              <TableCell
                align="right"
                style={{
                  padding: 0,
                  margin: 0,
                  paddingRight: '5px',
                  fontWeight: 'bold',
                  color: 'green',
                  fontSize: otherStyle.fontSize,
                }}
              >
                {profitorLoss === 'profit' && '₹ ' + MoneyFormatv3(Number(netProfit))}
              </TableCell>
            </TableRow>
          )}

          {/* Net Loss */}
          {heading === 'Income' && (
            <TableRow
              style={{
                height: otherStyle?.rowHeight,
                borderLeft: '1px solid #C0C0C0',
                borderRight: '1px solid #C0C0C0',
              }}
            >
              <TableCell
                style={{
                  padding: 0,
                  margin: 0,
                  borderRight: '4px solid ',
                  borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                  fontWeight: 'bold',
                  paddingLeft: '10px',
                  color: 'red',
                  fontSize: otherStyle.fontSize,
                }}
              >
                {profitorLoss === 'loss' && 'Net Loss'}
              </TableCell>
              <TableCell
                align="right"
                style={{
                  padding: 0,
                  margin: 0,
                  paddingRight: '5px',
                  fontWeight: 'bold',
                  color: 'red',
                  fontSize: otherStyle.fontSize,
                }}
              >
                {profitorLoss === 'loss' && '₹ -' + MoneyFormatv3(netLoss)}
              </TableCell>
            </TableRow>
          )}

          {/* Main Total */}
          <TableRow
            component={'row'}
            sx={{
              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? '#373a36' : theme?.palette?.bodyGray.tertiary,
              height: otherStyle?.rowHeight,
              borderLeft: '1px solid #C0C0C0',
              borderRight: '1px solid #C0C0C0',
            }}
          >
            <TableCell
              sx={{
                padding: 0,
                margin: 0,
                borderRight: '4px solid ',
                borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#ffff',
                fontWeight: 'bold',
                paddingLeft: '10px',
                fontSize: { xs: '14px', sm: '16px' },
              }}
            >
              Total
            </TableCell>
            <TableCell
              align="right"
              sx={{
                padding: 0,
                margin: 0,
                paddingRight: '5px',
                fontWeight: 'bold',
                color: `${mainTotal < 0 ? '#ff4a2b' : ''}`,
                fontSize: { xs: '14px', sm: '16px' },
                whiteSpace: 'nowrap',
              }}
            >
              {'₹ ' + MoneyFormatv3(mainTotal)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <LedgerModal {...ledgerModalParams} onSave={handleLedgerModal} onClose={closeLedgerModal} />

      <DeleteLedgerGroup
        open={openModal.deleteModal}
        setOpen={() => handleOpenModal('deleteModal')}
        setdeleteId={setdeleteId}
        selectedRow={selectedRow}
        setsuccessSnakbar={showSuccessSnackbar}
      />
      <AddPNFSales open={openModal.salesModal} setOpen={() => handleOpenModal('salesModal')} />
      <AddPNFPurchase open={openModal.purchaseModal} setOpen={() => handleOpenModal('purchaseModal')} />
      <AddPNFCreditNote open={openModal.creditNoteModal} setOpen={() => handleOpenModal('creditNoteModal')} />
      <AddPNFJournal open={openModal.journalModal} setOpen={() => handleOpenModal('journalModal')} />
      <AddPNFDebitNote open={openModal.debitNoteModal} setOpen={() => handleOpenModal('debitNoteModal')} />
      <AddBalanceSheetPayment open={openModal.paymentModal} setOpen={() => handleOpenModal('debitNoteModal')} groupName={groupName} />
      <AddBalanceSheetReceipt open={openModal.receiptModal} setOpen={() => handleOpenModal('receiptModal')} groupName={groupName} />

      {openModal.groupModal && (
        <CreateAndEditGroupModal
          open={openModal.groupModal}
          setOpen={() => handleOpenModal('groupModal')}
          groupId={selectedRow?.id}
          selectedRow={selectedRow}
          action={selectedRow?.action}
          setSelectedRow={setSelectedRow}
          setNewLedgerResponse={setNewLedgerResponse}
          page={'Dashboard'}
          tab={'ProfitNLoss'}
        />
      )}
    </>
  );
}

export default ProfitNLossTableNew;
